import { reactive }       from 'vue';
import BaseNotificationController from './BaseNotificationController';
export { NotificationsControllerSingleton as default };

/**
* Handles All Notifications
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class NotificationsController extends BaseNotificationController{}

const NotificationsControllerSingleton = reactive(new NotificationsController());